<script setup>
  const loaded = ref(false)
  const loadError = ref(false)

  onMounted(() => {
    const script = document.createElement('script')
    script.async = true
    script.src =
      'https://api.plezi.co/api/v1/web_forms/scripts?tenant_id=65080723f420876f571f1279&form_id=651bda4ed59cbc49559b5b54&form_version=3&content_web_form_id=65490f1ed59cbc2cfd671939'
    script.onload = () => {
      loaded.value = true
      // Apply CSS after form is loaded
      const style = document.createElement('style')
      style.innerHTML = `
      #foss-65490f1ed59cbc2cfd671939 {
        font-family: 'Gravur Condensed' !important;
      }
      .form-control {
        box-shadow: none !important;
      }
      .control-label {
        font-size: 1rem !important;
      }
      .checkbox input[type="checkbox"] {
        size: 1rem !important;
        color: rgb(88 217 219) !important;
        margin: 0px 4px 3px 4px !important;
        margin-bottom: 3px !important;
        border-radius: 0.25rem !important;
        border: 1px solid rgb(88 217 219) !important;
        outline: none !important;
      }
      .plezi-submit-btn {
        font-family: 'Gilroy' !important;
        font-weight: 700 !important;
      }
      .plezi-submit-btn:hover {
        background-color: #1FB6BB !important;
      }
    `
      document.head.appendChild(style)
    }
    script.onerror = () => (loadError.value = true)
    document.getElementById('foss-65490f1ed59cbc2cfd671939').appendChild(script)
  })
</script>

<template>
  <Page code="contact" :hero="true">
    <div class="mx-auto max-w-screen-sm px-4 py-16">
      <div class="text-center font-special text-3xl font-bold">Envie d’en savoir plus&nbsp;?</div>
      <p class="mt-8 text-center">
        👉 N’hésitez pas à nous contacter pour en savoir + sur le fonctionnement de Profil Public. Nous vous répondrons rapidement.
      </p>
      <div class="mt-8">
        <Loading v-show="!loaded" size="2xl" />
        <form id="foss-65490f1ed59cbc2cfd671939"></form>
        <p class="text-center text-red-500" v-if="loadError">Erreur lors du chargement du formulaire :(</p>
      </div>
    </div>
  </Page>
</template>
